// extracted by mini-css-extract-plugin
module.exports = {"select":"Bankruptcy_select__1WfK9","row":"Bankruptcy_row__3-kz_","button":"Bankruptcy_button__39ICW","input":"Bankruptcy_input__GFPTT"};